export const environment = {
  production: false,
  apiBaseUrl:
    'https://netto-dotnet-api-dev.victoriousbay-b30dd2b8.polandcentral.azurecontainerapps.io',
  appInsightsConnectionString:
    'InstrumentationKey=2fb1d3b6-dd4c-48fd-80b5-67902714ca95;IngestionEndpoint=https://southcentralus-3.in.applicationinsights.azure.com/;LiveEndpoint=https://southcentralus.livediagnostics.monitor.azure.com/;ApplicationId=019bef75-d7eb-49ff-ba28-3811e67ed4bd',
};
